import { useState } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import AccountFormModal from 'dashboard-account/components/AccountFormModal'
import { loginPendingSelector } from 'login-and-signup/selectors'
import CloseButton from '@components/CloseButton'
import useRequestPending from 'shared/hooks/useRequestPending'
import featureToggles from 'shared/featureToggles'

import { userDetailsSelector } from 'auth/selectors'

import styles from './styles.module.scss'

const Reminders = ({ userDetails, pending }) => {
    const [openAccountForm, setOpenAccountForm] = useState(false)
    const [openThanks, setOpenThanks] = useState(false)

    useRequestPending(pending, () => {
        if (featureToggles.additionalSignupData) {
            const { phone, document: { type } = {} } = userDetails || {}
            setOpenAccountForm(!phone || !type)
        }
    })

    return (
        <>
            {openThanks && (
                <div className={styles.thanks}>
                    <T>dashboard.reminder.thanks</T>
                    <CloseButton action={() => setOpenThanks(false)} />
                </div>
            )}
            {openAccountForm && (
                <AccountFormModal
                    onSuccess={() => {
                        setOpenThanks(true)
                        setOpenAccountForm(false)
                    }}
                    onClose={() => setOpenAccountForm(false)}
                />
            )}
        </>
    )
}

export default compose(
    connect(
        createStructuredSelector({
            pending: loginPendingSelector,
            userDetails: userDetailsSelector,
        })
    )
)(Reminders)
